/* Erkennung von Fehlern der Supabase-Anmeldung — reine Funktion, kein DOM.
 *
 * Supabase begrenzt den Mailversand pro Stunde (Einladung, Passwort-Zurücksetzen, Anmeldelink). Wird das
 * Limit überschritten, antwortet Auth mit Status 429 und dem Code `over_email_send_rate_limit`
 * (ältere Versionen: Meldung "email rate limit exceeded"). Nur DIESER Fall bekommt eine eigene, verständliche
 * Meldung (errors.emailRateLimit). Andere 429-Fehler (z. B. over_request_rate_limit, zu viele Anfragen
 * insgesamt) und alle sonstigen Fehler bleiben, wie sie sind — sie werden nicht als Mail-Limit ausgegeben.
 *
 * Die Edge Function invite-user führt dieselbe Regel (supabase/functions/invite-user/decision.ts,
 * classifyInviteError); src/domain/authErrors.test.js vergleicht beide.
 */

/** Ist das der Fehler "zu viele E-Mails in der letzten Stunde"? `err` ist das Fehlerobjekt von supabase-js. */
export function isEmailRateLimit(err) {
  if (!err || typeof err !== 'object') return false;
  if (err.code === 'over_email_send_rate_limit') return true;
  return err.status === 429 && /email rate limit exceeded/i.test(String(err.message ?? ''));
}
